/**
 * @generated SignedSource<<38b05a5fa67d1700822f4b3c4ee7660c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRegionMutation$variables = {
  id: string;
};
export type DeleteRegionMutation$data = {
  readonly deleteRegion: {
    readonly id: string;
  };
};
export type DeleteRegionMutation = {
  response: DeleteRegionMutation$data;
  variables: DeleteRegionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteRegionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "deleteRegion",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteRegionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "deleteRegion",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eeee39f656430132403ba00fba7a444f",
    "id": null,
    "metadata": {},
    "name": "DeleteRegionMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteRegionMutation(\n  $id: ID!\n) {\n  deleteRegion(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd2dc6c26d99ff6a114302fabd5f7879";

export default node;
